<template>
  <component
    :is="productClickable ? 'a' : 'span'"
    :href="productClickable ? product.url || product.productUrl : null"
    class="product-name"
  >
    {{ product.name }}
    <span
      class="product-name__bottles"
      v-if="product.numberOfBottlesInSet && product.numberOfBottlesInSet > 1"
    >
      {{ $t('product.name.bottlesInSet', [product.numberOfBottlesInSet]) }}
    </span>
  </component>
</template>

<script lang="ts">
  import {Vue, Options, Prop} from 'vue-property-decorator';
  import BasketItem from '../../../bps/types/BasketItem';
  import ProductBoxData from '../../../bps/types/ProductBoxData';
  import Product from '../../../bps/types/Product';
  import type AccountOrderItem from '../../../bps/types/AccountOrderItem';

  @Options({
    name: 'product-name'
  })
  export default class ProductName extends Vue {
    @Prop({default: true})
    readonly productClickable: boolean;
    @Prop({required: true})
    readonly product: BasketItem | ProductBoxData | Product | AccountOrderItem;
  }
</script>
